import React from 'react';
import { motion } from 'framer-motion';
import { ParticleBackground } from './ParticleBackground';
import { CTAButton } from './CTAButton';
import { BookOpen, Sparkles, Crown } from 'lucide-react';
const LEVELS = [{
  icon: BookOpen,
  title: 'Nivel 1',
  desc: 'Iniciación y fundamentos del Reiki. Aprendé a canalizar energía para vos mismo/a.',
  color: 'text-blue-400'
}, {
  icon: Sparkles,
  title: 'Nivel 2',
  desc: 'Símbolos sagrados y sanación a distancia. Expandí tu práctica.',
  color: 'text-violet-400'
}, {
  icon: Crown,
  title: 'Nivel Maestría',
  desc: 'Convertite en Maestro/a de Reiki. Enseñá y sintonizá a otros.',
  color: 'text-yellow-400'
}];
export function SolutionSection() {
  return <section className="relative py-24 px-4 bg-dark-bg-alt overflow-hidden" data-id="element-202">
      <ParticleBackground data-id="element-203" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-display font-bold text-white mb-4" data-id="element-206">
            Presentamos el{' '}
            <span className="gradient-text-violet" data-id="element-207">Reiki MegaPack</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-violet-200/80 max-w-2xl mx-auto" data-id="element-208">
            La Solución Completa Para Tu Transformación Energética
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-dark-surface/50 backdrop-blur-sm border border-violet-500/20 rounded-2xl p-8 mb-16 text-center max-w-4xl mx-auto" data-id="element-209">
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-210">
            Hemos recopilado el conocimiento ancestral del Reiki Usui en un
            formato digital accesible, completo y fácil de seguir. No importa si
            nunca escuchaste hablar de chakras o si ya tenés experiencia, este
            pack te lleva de la mano en cada paso.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-211">
          {LEVELS.map((level, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-dark-surface border border-violet-500/30 rounded-xl p-8 hover:border-violet-500/60 transition-colors duration-300 group" data-id="element-212">
              <div className={`w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-213">
                <level.icon className={`w-8 h-8 ${level.color}`} data-id="element-214" />
              </div>
              <h3 className="text-2xl font-display font-bold text-white mb-4" data-id="element-215">
                {level.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-216">{level.desc}</p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-217">
          <CTAButton text="¡QUIERO EMPEZAR MI CAMINO!" data-id="element-218" />
        </div>
      </div>
    </section>;
}